
  
  export const gradientColors = [
    "linear-gradient(to top, #006400, #228B22)", // green
    "linear-gradient(to bottom, #ff512f, #ffb02f)", // yellow
    "linear-gradient(to top, #ff416c, #ff4b2b)", // red
  ];
  